var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { logGroup } from 'hx-util';
import { AUDIO_SETS } from './audioset';
import { hanningRampInOut } from './hanning_ramp';
import { makeRequest } from './request';
import { PlayMode, RAMP_TIME, } from './types';
import { getDBOffsets } from './util';
var WebAudioPlayer = /** @class */ (function () {
    function WebAudioPlayer(ac, masterGain) {
        this.playingBuffers = [];
        this.audioSetBuffers = {};
        this.audioSets = {};
        this.isPlaying = false;
        this.initialized = false;
        this.audioContext = ac;
        this.dinPlayerGain = this.audioContext.createGain();
        this.dinPlayerGain.connect(masterGain);
        this.dinPlayerGain.gain.value = 0.5;
    }
    WebAudioPlayer.prototype.isInitialised = function () {
        return this.initialized;
    };
    WebAudioPlayer.prototype.loadAudio = function (setNames, progressCallback) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolveAll, rejectAll) {
                        var promises = [];
                        var promiseFinishedCount = 0;
                        var progressFn = function () {
                            promiseFinishedCount += 1;
                            if (progressCallback) {
                                progressCallback(Math.round((promiseFinishedCount / promises.length) * 100));
                            }
                        };
                        setNames.forEach(function (setName) {
                            _this.audioSetBuffers[setName] = _this.audioSetBuffers[setName] || {};
                            if (!AUDIO_SETS[setName]) {
                                return;
                            }
                            var set = AUDIO_SETS[setName];
                            _this.audioSets[setName] = set;
                            set.files().forEach(function (file) {
                                promises.push(new Promise(function (resolve, reject) {
                                    _this.loadBuffer(file.path, progressFn)
                                        .then(function (buffer) {
                                        _this.audioSetBuffers[setName][file.name] = buffer;
                                        resolve();
                                    })
                                        .catch(reject);
                                }));
                            });
                        });
                        Promise.all(promises)
                            .then(function () {
                            _this.initialized = true;
                            resolveAll();
                        })
                            .catch(rejectAll);
                    })];
            });
        });
    };
    WebAudioPlayer.prototype.clearAudioCache = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                console.log(this);
                return [2 /*return*/];
            });
        });
    };
    WebAudioPlayer.prototype.warmUp = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                // if (this.audio_sets == null) {
                //   return Promise.reject("audio set is null");
                // }
                // this.startVolumeTriplet().then(() => this.stopVolumeTriplet());
                console.log(this);
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    WebAudioPlayer.prototype.playFile = function (setName, fileName, mode) {
        return __awaiter(this, void 0, Promise, function () {
            var buffer, pb, mixer;
            return __generator(this, function (_a) {
                buffer = this.getAudioBuffer(setName, fileName);
                pb = this.createPlayingBuffer(buffer);
                mixer = this.createMixerNode(pb.outputNode, mode);
                pb.outputNode = mixer;
                this.queueBuffer(pb);
                pb.source.start(pb.start);
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    WebAudioPlayer.prototype.playTriplet = function (setName, mode, snr, triplet, noCarrier, noNoise) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var audioSet, _a, fnCarrier, fnD1, fnD2, fnD3, fnNoise, _b, bCarrier, bD1, bD2, bD3, bNoise, dbOffsets, digitCarrierGain, noiseGain, offsetSeconds, startTime, pbNoise, pbCarrier, pbDigit1, pbDigit2, pbDigit3, e_1;
                        var _this = this;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _c.trys.push([0, 2, , 3]);
                                    if (!this.audioSets ||
                                        !this.audioSets[setName] ||
                                        !this.audioSetBuffers[setName]) {
                                        reject('Audio not loaded or invalid setName');
                                    }
                                    audioSet = this.audioSets[setName];
                                    // stop all first
                                    return [4 /*yield*/, this.stop()];
                                case 1:
                                    // stop all first
                                    _c.sent();
                                    _a = [
                                        audioSet.carrierFileName ? audioSet.carrierFileName() : null,
                                        audioSet.digitFileName(triplet[0], 1),
                                        audioSet.digitFileName(triplet[1], 2),
                                        audioSet.digitFileName(triplet[2], 3),
                                        audioSet.noiseFileName(),
                                    ], fnCarrier = _a[0], fnD1 = _a[1], fnD2 = _a[2], fnD3 = _a[3], fnNoise = _a[4];
                                    _b = [
                                        fnCarrier ? this.getAudioBuffer(setName, fnCarrier) : null,
                                        this.getAudioBuffer(setName, fnD1),
                                        this.getAudioBuffer(setName, fnD2),
                                        this.getAudioBuffer(setName, fnD3),
                                        this.getAudioBuffer(setName, fnNoise),
                                    ], bCarrier = _b[0], bD1 = _b[1], bD2 = _b[2], bD3 = _b[3], bNoise = _b[4];
                                    dbOffsets = getDBOffsets(snr);
                                    digitCarrierGain = Math.pow(10, (dbOffsets.digitCarrier / 20));
                                    noiseGain = Math.pow(10, (dbOffsets.noise / 20));
                                    logGroup("Playing Triplet ".concat(triplet.join('')), {
                                        setName: setName,
                                        mode: mode,
                                        Triplet: triplet.join(''),
                                        SNR: snr,
                                        Digits: dbOffsets.digitCarrier,
                                        Noise: dbOffsets.noise,
                                        Volume: this.dinPlayerGain.gain.value,
                                    });
                                    offsetSeconds = this.audioContext.currentTime;
                                    this.isPlaying = true;
                                    startTime = offsetSeconds;
                                    pbNoise = null;
                                    if (!noNoise) {
                                        pbNoise = this.createPlayingBuffer(bNoise);
                                        pbNoise.source.start(offsetSeconds);
                                        pbNoise.gain.gain.value = noiseGain;
                                        pbNoise.outputNode = this.createMixerNode(pbNoise.gain, PlayMode.BinauralInPhase);
                                        offsetSeconds += 0.5;
                                    }
                                    pbCarrier = null;
                                    if (bCarrier && !noCarrier) {
                                        pbCarrier = this.createPlayingBuffer(bCarrier);
                                        pbCarrier.source.start(offsetSeconds);
                                        pbCarrier.gain.gain.value = digitCarrierGain;
                                        offsetSeconds += bCarrier.duration;
                                    }
                                    pbDigit1 = this.createPlayingBuffer(bD1);
                                    pbDigit1.source.start(offsetSeconds);
                                    pbDigit1.gain.gain.value = digitCarrierGain;
                                    pbDigit1.outputNode = this.createMixerNode(pbDigit1.gain, mode);
                                    offsetSeconds += bD1.duration + 0.155;
                                    pbDigit2 = this.createPlayingBuffer(bD2);
                                    pbDigit2.source.start(offsetSeconds);
                                    pbDigit2.gain.gain.value = digitCarrierGain;
                                    pbDigit2.outputNode = this.createMixerNode(pbDigit2.gain, mode);
                                    offsetSeconds += bD2.duration + 0.155;
                                    pbDigit3 = this.createPlayingBuffer(bD3);
                                    pbDigit3.source.start(offsetSeconds);
                                    pbDigit3.gain.gain.value = digitCarrierGain;
                                    pbDigit3.outputNode = this.createMixerNode(pbDigit3.gain, mode);
                                    offsetSeconds += bD3.duration + 0.5;
                                    // stop noise
                                    if (pbNoise) {
                                        pbNoise.stop = offsetSeconds;
                                        hanningRampInOut(pbNoise, RAMP_TIME, noiseGain);
                                        pbNoise.source.stop(pbNoise.stop);
                                        this.queueBuffer(pbNoise);
                                    }
                                    if (pbCarrier)
                                        this.queueBuffer(pbCarrier);
                                    this.queueBuffer(pbDigit1);
                                    this.queueBuffer(pbDigit2);
                                    this.queueBuffer(pbDigit3);
                                    setTimeout(function () {
                                        _this.isPlaying = false;
                                        resolve();
                                    }, (offsetSeconds - startTime) * 1000);
                                    return [3 /*break*/, 3];
                                case 2:
                                    e_1 = _c.sent();
                                    reject(e_1);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    WebAudioPlayer.prototype.stop = function () {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_c) {
                if (!((_a = this.playingBuffers) === null || _a === void 0 ? void 0 : _a.length))
                    return [2 /*return*/];
                (_b = this.playingBuffers) === null || _b === void 0 ? void 0 : _b.forEach(function (pb) {
                    try {
                        pb.source.stop();
                    }
                    catch (e) {
                        console.error("error setting gain: ".concat(e));
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    WebAudioPlayer.prototype.setVolume = function (v) {
        this.dinPlayerGain.gain.value = v / 100;
        // this.playingBuffers.forEach((pb) => {
        //   pb.gain.gain.value = v / 100;
        // });
    };
    WebAudioPlayer.prototype.getVolume = function () {
        return this.dinPlayerGain.gain.value * 100;
    };
    WebAudioPlayer.prototype.loadBuffer = function (filename, successCB) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, makeRequest('GET', window.location.origin + '/' + filename, 'arraybuffer').then(function (arrBuf) {
                        return new Promise(function (resolve, reject) {
                            return _this.audioContext.decodeAudioData(arrBuf, resolve, function (e) {
                                return reject(new Error("decode failed for ".concat(filename, ": ").concat(e)));
                            });
                        }).then(function (audBuf) {
                            successCB(filename);
                            return Promise.resolve(audBuf);
                        });
                    })];
            });
        });
    };
    WebAudioPlayer.prototype.getAudioBuffer = function (setName, fileName) {
        var buffers = this.audioSetBuffers[setName];
        if (!buffers || !buffers[fileName]) {
            throw new Error("audio file \"".concat(setName, "/").concat(fileName, "\" not found"));
        }
        return buffers[fileName];
    };
    WebAudioPlayer.prototype.createMixerNode = function (source, playMode) {
        var _this = this;
        var mute = function (src) {
            var muter = _this.audioContext.createGain();
            muter.gain.value = 0;
            src.connect(muter);
            return muter;
        };
        var reverse = function (src) {
            var reverser = _this.audioContext.createGain();
            reverser.gain.value = -1;
            src.connect(reverser);
            return reverser;
        };
        var nin = this.audioContext.createChannelSplitter(2);
        var nout = this.audioContext.createChannelMerger(2);
        switch (playMode) {
            case PlayMode.BinauralInPhase:
                nin.connect(nout, 0, 0);
                nin.connect(nout, 0, 1);
                break;
            case PlayMode.BinauralOutOfPhase:
                nin.connect(nout, 0, 0);
                reverse(nin).connect(nout, 0, 1);
                break;
            case PlayMode.MonoauralLeft:
                nin.connect(nout, 0, 0);
                mute(nin).connect(nout, 0, 1);
                break;
            case PlayMode.MonoauralRight:
                mute(nin).connect(nout, 0, 0);
                nin.connect(nout, 0, 1);
                break;
            default:
                throw new Error('unknown mode');
        }
        source.connect(nin);
        return nout;
    };
    WebAudioPlayer.prototype.createPlayingBuffer = function (buffer) {
        var source = this.audioContext.createBufferSource();
        source.buffer = buffer;
        var gain = this.audioContext.createGain();
        gain.gain.value = 1;
        source.connect(gain);
        return {
            source: source,
            gain: gain,
            outputNode: gain,
            start: this.audioContext.currentTime,
            stop: null,
        };
    };
    WebAudioPlayer.prototype.queueBuffer = function (buffer) {
        // console.log("queing buffer", buffer);
        // buffer.source.start(buffer.start);
        // if (buffer.stop) {
        //   buffer.source.stop(buffer.stop);
        // }
        var _this = this;
        buffer.source.onended = function () {
            var idx = _this.playingBuffers.indexOf(buffer);
            if (idx > -1) {
                // console.log("play complete, removing buffer");
                _this.playingBuffers.splice(idx, 1);
            }
        };
        this.playingBuffers.push(buffer);
        buffer.outputNode.connect(this.dinPlayerGain);
        // buffer.outputNode.connect(this.audioContext.destination);
    };
    return WebAudioPlayer;
}());
export default WebAudioPlayer;
